import { Controller } from "@hotwired/stimulus"

const PRIORITY_TYPES = new Set(["MX", "SRV", "CAA", "TLSA", "NAPTR", "URI"])

export default class extends Controller {
  static targets = ["priorityField", "typeSelect"]

  connect() {
    this.togglePriority()
  }

  togglePriority() {
    const show = PRIORITY_TYPES.has(this.typeSelectTarget.value)
    this.priorityFieldTargets.forEach(el => el.classList.toggle("d-none", !show))
  }
}
